import { render } from "./CreateUser.vue?vue&type=template&id=e101a636"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"
script.render = render

export default script